import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["word"]
  static values = {
    questionId: Number,
    submitUrl: String,
    max: Number
  }

  connect() {
    this.submitted = false
  }

  async submit() {
    if (this.submitted) return
    this.submitted = true

    const words = this.wordTargets
      .map((input) => input.value.trim())
      .filter((w) => w.length > 0)
      .slice(0, this.maxValue)

    if (words.length === 0) {
      this.submitted = false
      return
    }

    try {
      const response = await fetch(this.submitUrlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content,
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          question_id: this.questionIdValue,
          payload: { words: words }
        })
      })
      if (!response.ok) throw new Error(`Submit failed: ${response.status}`)
      this.element.classList.add("opacity-50", "pointer-events-none")
    } catch (error) {
      console.error("Word cloud submit failed:", error)
      this.submitted = false
    }
  }
}
